import { useCallback } from 'react';
import { ConnectionHandler, commitLocalUpdate, useRelayEnvironment } from 'react-relay';
import { useNavigationProject } from '@atlassian/jira-business-entity-project/src/services/navigation-project/index.tsx';
import { useProjectConnectItems } from '@atlassian/jira-navigation-apps-sidebar-connect/src/controllers/project/index.tsx';
import { useProjectForgeApps } from '@atlassian/jira-navigation-apps-sidebar-forge/src/controllers/project/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

/** @deprecated delete when cleaning up getWillShowNav4 */
export const useHideAppsTab = () => {
	const { project } = useNavigationProject();
	const { cloudId } = useTenantContext();
	const { data: forgeAppsData, loading: forgeAppsLoading } =
		useProjectForgeApps('forge-spa-project');
	const { data: connectAppsData, loading: connectAppsLoading } = useProjectConnectItems();
	const forgeItems = forgeAppsData ?? [];
	const connectItems = connectAppsData ?? [];

	const totalNumberOfApps = forgeItems.length + connectItems.length;
	const hasApps = totalNumberOfApps > 0;

	const isLoading = forgeAppsLoading || connectAppsLoading;
	const shouldRenderApps = project != null && hasApps;

	const environment = useRelayEnvironment();

	return useCallback(() => {
		if (!isLoading && !shouldRenderApps) {
			commitLocalUpdate(environment, (store) => {
				const projectIdOrKey = String(project?.key || project?.id);
				const parentRecord = store.getRoot().getLinkedRecord('jira');
				if (parentRecord == null) {
					return;
				}

				const connection = ConnectionHandler.getConnection(
					parentRecord,
					'tabs_jiraNavigation__navigationItems',
					{
						cloudId,
						projectIdOrKey,
					},
				);

				if (!connection) return;

				const existingEdges = connection?.getLinkedRecords('edges') || [];
				const edges = existingEdges.filter((edge) => {
					const typeKey = edge?.getLinkedRecord('node')?.getValue('typeKey');
					return typeKey !== 'APPS';
				});
				connection?.setLinkedRecords(edges, 'edges');
			});
		}
	}, [cloudId, environment, isLoading, project?.id, project?.key, shouldRenderApps]);
};
